export default "__VITE_ASSET__fe97f8cb__"